import Vue from "vue";
import configPlugin from "@/config";

import VueSession from "vue-session";
import { BootstrapVue, IconsPlugin, BootstrapVueIcons } from "bootstrap-vue";
import vmodal from "vue-js-modal";
import VeeValidate from "vee-validate";
import vSelect from "vue-select";

import axios from "axios";
import VueAxios from "vue-axios";
import VueCryptojs from "vue-cryptojs";

import App from "./App.vue";
import router from "./router";
import { store } from "./store";

import { VuePicker, VuePickerOption } from "@invisiburu/vue-picker";
// optional css
import "@invisiburu/vue-picker/dist/vue-picker.min.css";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import titleMixin from "./mixins/titleMixin";

// sentry
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(BootstrapVueIcons);

Vue.component("VuePicker", VuePicker);
Vue.component("VuePickerOption", VuePickerOption);
import "@invisiburu/vue-picker/dist/vue-picker.min.css";

Vue.use(VueSession, { persist: true });
Vue.use(vmodal, {
    dynamicDefaults: {
        draggable: true,
        resizable: true,
        height: "auto",
        dialog: true
    }
});

Vue.use(configPlugin);
Vue.use(VeeValidate);
Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.use(VueCryptojs);
Vue.component("v-select", vSelect);

Vue.mixin(titleMixin);

Sentry.init({
    Vue,
    dsn: "https://ab81502c2355405b82636c43f83a28f6@sentry.sonnenbatterie.de/91",
    integrations: [
        new BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracingOrigins: ["localhost", "bi-app.vpp-prep.sonnen.de", /^\//]
        })
    ],
    tracesSampleRate: 1.0
});

new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount("#app");
